/**
 *  创意列表有关
 * */
import apis from 'src/const/apis';
import request from 'src/utils/request';
import * as types from '../../types';

export default {
  namespaced: true,
  state: {
    adListToken: null,
  },
  mutations: {
    [types.SET_REQUEST_TOKEN](state, data) {
      state.adListToken = data;
    },
  },
  actions: {
    getCreativeList({ state, commit }, data) {
      // 重复请求时清除之前的请求
      if (state.adListToken) {
        state.adListToken.cancel();
      }

      const cancelToken = request.axios.CancelToken;
      const source = cancelToken.source();
      commit(types.SET_REQUEST_TOKEN, source);
      return request.post(apis.creative.newStatisticList, data, {
        cancelToken: source.token,
      });
    },
    getCreativeInfo(store, data) {
      return request.get(apis.creative.info, data);
    },
    getNewCreativeInfo(store, data) {
      return request.get(apis.creative.new_info, data);
    },
    getNewCreativeProceduralInfo(store, data) {
      return request.get(apis.creative.new_procedural_info, data);
    },
    updateCreativeStatus({ commit }, data) {
      commit(`perf/${types.SET_PERF_OPERATED_ANCHOR}`, {}, { root: true });
      return request.postForm(apis.creative.update_status, data);
    },
  },
};
